<template>
  <div>
    <v-layout class="related-searches mb-4">
      <v-flex
        wrap
        class="display-18 related-searches-header d-flex"
        align-center
        max-width="100px"
      >
        <p class="text-center pl-3 pr-3 white--text pb-0 mb-0">
          חיפושים קשורים
        </p>
      </v-flex>

      <v-flex class="related-searches-text d-flex align-center display-16" pa-2>
        <v-layout column>
          <v-flex xs12>
            <AllSuggestions
              v-if="showAllSuggestions"
              :allSuggestions="allSuggestions"
              :categoryLink="categoryLink"
              :subCategoryLink="subCategoryLink"
              :zoneLink="zoneLink"
              :regionLink="regionLink"
            />

            <!-- ------------------------------------------------------------------------------------------ -->
            <ZoneSuggestions
              v-else-if="showRegionLink || showZoneLink"
              :showRegionLink="showRegionLink"
              :showZoneLink="showZoneLink"
              :zoneSuggestion="zoneSuggestion"
              :regionSuggestion="regionSuggestion"
              :regionLink="regionLink"
              :zoneLink="zoneLink"
            />

            <!-- --------------------------------------------------------------------------------------- -->
            <SubCatSuggestions
              v-else-if="showCategoryLink || showSubCategoryLink"
              :showSubCategoryLink="showSubCategoryLink"
              :showCategoryLink="showCategoryLink"
              :categorySuggestion="categorySuggestion"
              :subCategorySuggestion="subCategorySuggestion"
              :categoryLink="categoryLink"
              :subCategoryLink="subCategoryLink"
            />
          </v-flex>

          <v-flex mr-2>
            <div v-if="isExactMatch">
              או האם ברצונך לחפש את הביטוי המדויק '
              <nuxt-link :to="`/jobs/search/${exactMatch}/?exact=1`">
                <span class="primary--text">{{ exactMatch }}</span> </nuxt-link
              >'?
            </div>

            <div v-else-if="isLinkToExtendedSearch">
              האם ברצונך לחזור לחיפושך הקודם
              <nuxt-link :to="`/jobs/search/?${exactMatch}`">
                <span class="primary--text">{{ exactMatch }}</span> </nuxt-link
              >'?
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- -------------------------------------------------------------- -->
  </div>
</template>

<script>
import { isEmpty, trimEnd, includes } from 'lodash'

import ZoneSuggestions from '@/components/Jobs_List/Jobs_On_Drushim/Suggestions/ZoneSuggestions'
import SubCatSuggestions from '@/components/Jobs_List/Jobs_On_Drushim/Suggestions/SubCatSuggestions'
import AllSuggestions from '@/components/Jobs_List/Jobs_On_Drushim/Suggestions/AllSuggestions'

function proccessString(query, codesArray) {
  let str = ''
  str = str.concat(query, '=')
  codesArray.forEach((code) => {
    str = str.concat(code, '-')
  })
  return trimEnd(str, '-')
}

export default {
  components: {
    ZoneSuggestions,
    SubCatSuggestions,
    AllSuggestions,
  },

  props: {
    searchSuggestions: {
      type: Object,
      required: false,
      default: () => {},
    },
    searchTerm: {
      type: String,
      required: false,
      default: undefined,
    },
  },

  data() {
    return {
      allSuggestions: {},
      zoneSuggestion: undefined,
      regionSuggestion: undefined,
      categorySuggestion: undefined,
      subCategorySuggestion: undefined,
    }
  },

  mounted() {
    this.initSeggestionsData()
  },

  methods: {
    initSeggestionsData() {
      let temp = Object.entries(this.searchSuggestions).filter((i) => {
        return includes(i[0], 'Recommended')
      })
      temp.forEach((i) => {
        if (includes(i[0], 'Zones')) {
          this.zoneSuggestion = { ...i[1] }
        }
        if (includes(i[0], 'Regions')) {
          this.regionSuggestion = { ...i[1] }
        }
        if (includes(i[0], 'Categories')) {
          this.categorySuggestion = { ...i[1] }
        }
        if (includes(i[0], 'SubCategories')) {
          this.subCategorySuggestion = { ...i[1] }
        }
      })
      this.allSuggestions.zone = this.zoneSuggestion
      this.allSuggestions.region = this.regionSuggestion
      this.allSuggestions.category = this.categorySuggestion
      this.allSuggestions.subCategory = this.subCategorySuggestion
    },
  },

  computed: {
    showAllSuggestions() {
      return (this.showZoneLink && this.showCategoryLink) ||
        (this.showZoneLink && this.showSubCategoryLink) ||
        (this.showRegionLink && this.showSubCategoryLink) ||
        (this.showRegionLink && this.showCategoryLink)
        ? true
        : false
    },

    isLinkToExtendedSearch() {
      return this.searchSuggestions
        ? this.searchSuggestions.OfferBackToExtendedSearch
        : false
    },

    isExactMatch() {
      return this.searchSuggestions
        ? this.searchSuggestions.OfferExactSearch
        : false
    },

    exactMatch() {
      if (this.isExactMatch) {
        return this.searchTerm
      }
      return
    },

    showZoneLink() {
      return !isEmpty(this.zoneSuggestion, false)
    },

    zoneLink() {
      if (this.showZoneLink) {
        let str
        let query = ''
        let temp = this.zoneSuggestion[0].Item.RegionIds
        str = proccessString(query, temp)
        str = str.substr(1)
        return str
      }
      return
    },

    showRegionLink() {
      return !isEmpty(this.regionSuggestion, false)
    },

    regionLink() {
      if (this.showRegionLink) {
        return this.regionSuggestion[0].Item.Code
      }
    },

    showCategoryLink() {
      return !isEmpty(this.categorySuggestion, false)
    },

    categoryLink() {
      if (this.showCategoryLink) {
        return this.categorySuggestion[0].Item.Code
      }
    },

    showSubCategoryLink() {
      return !isEmpty(this.subCategorySuggestion, false)
    },

    subCategoryLink() {
      if (this.showSubCategoryLink) {
        return this.subCategorySuggestion[0].Item.Code
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.related-searches {
  min-height: 71px;
  object-fit: contain;
  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.46);
  background-color: #fefefe;
}

.related-searches-header {
  background-color: $primary;
  max-width: 160px;
  height: auto;
}
.related-searches-text {
  height: auto;
}
.related-searches-header p {
  white-space: nowrap;
}

.related-searches-text p span {
  color: $primary;
}

span {
  display: inline;
}
</style>
